import { Component, Input } from '@angular/core';
import ColorUtils from '@shared/utils/color-utils';

@Component({
  selector: 'dp-badge',
  template: '<span class="inline wd-xxs badge" ' +
    '[ngClass]="size"' +
    '[ngStyle]="badgeStyle">' +
    '<i *ngIf="icon" class="{{icon}}"></i>' +
    '{{text}}</span>',
  styleUrls: ['./dp-badge.component.scss']
})
export class DpBadgeComponent {

  private _textColor: string = '#fff';

  private _text: string;

  get text(): string {
    return this._text;
  }

  @Input()
  set text(value: string) {
    this._text = value;

    if (value) {
      value = value.toString().toUpperCase();
      switch (value) {
        case 'EMAIL ONLY':
          this._color = 'red';
          break;
        case 'OST':
          this._color = 'orange';
          break;
        case 'RECALL':
          this._color = 'purple';
          break;
        case 'REDO':
          this._color = 'red';
          break;
      }
    }
  }

  private _icon: string = null;

  get icon(): string {
    return this._icon;
  }

  @Input()
  set icon(value: string) {
    this._icon = value;
  }

  private _size: string = 'wd-xxs';

  get size(): string {
    return this._size;
  }

  @Input()
  set size(value: string) {
    this._size = value;
  }

  private _color: string;

  get color(): string {
    return this._color;
  }

  @Input()
  set color(value: string) {
    this._color = value;
    this._textColor = ColorUtils.stringToColor(value).fgColor || '#fff';
  }

  get badgeStyle(): object {
    if (this.color) {
      return {
        color: this._textColor,
        background: this.color
      }
    } else {
      return {
        background: '#eee'
      }
    }
  }

}
